module.exports = __webpack_public_path__ + "img/carousel-premium.b8d4903a.jpg";